module.exports = __webpack_public_path__ + "img/nav8.30ae0786.png";